import { ModuleDataSyncService } from '@application/persistence/ModuleDataSyncService';

export interface ModuleDataRow {
  id: string;
  tenant_id: string;
  namespace: string;
  value: unknown;
}

/** Données métier tenant-scopées (SQLite local ou sync business-api). */
export class SecureTenantStore {
  static isAvailable(): boolean {
    return ModuleDataSyncService.isAvailable();
  }

  static async getJson<T>(
    tenantId: string,
    namespace: string,
    fallback: T,
    legacyKey?: string,
  ): Promise<T> {
    return ModuleDataSyncService.getJson(tenantId, namespace, fallback, legacyKey);
  }

  static async setJson(
    tenantId: string,
    namespace: string,
    value: unknown,
    legacyKey?: string,
  ): Promise<void> {
    return ModuleDataSyncService.setJson(tenantId, namespace, value, legacyKey);
  }

  static async migrateLegacyKey(
    tenantId: string,
    namespace: string,
    legacyKey: string,
  ): Promise<boolean> {
    return ModuleDataSyncService.migrateLegacyKey(tenantId, namespace, legacyKey);
  }

  static async listForTenant(tenantId: string): Promise<ModuleDataRow[]> {
    return ModuleDataSyncService.listForTenant(tenantId);
  }
}
